import {format} from 'utils'
import request from 'crm/utils/request'
import api from 'crm/common/api/extended-data'

export async function list() {
    return request(api.list.url)
}

export async function create(payload) {
    return request(api.create.url, {
        method: api.create.type,
        body: payload.body,
    })
}

export async function update(payload) {
    return request(`${format(api.update.url, {id: payload.id})}`, {
        method: api.update.type,
        body: payload.body,
    })
}

export async function remove(payload) {
    return request(`${format(api.remove.url, {id: payload.id})}`, {
        method: api.remove.type,
    })
}

export async function detail(payload) {
    return request(format(api.detail.url, {id: payload.id}))
}

export async function swap(payload) {
    return request(api.swap.url, {
        method: api.swap.type,
        body: payload.body,
    })
}
